import { cdnImageUrl } from 'helpers/image'
import React from 'react'

interface ICdnImageProps {
  alt?: string
  className?: string
  height: number
  imageHash: string | { hash: string }
  trim?: boolean
  transparent?: boolean
  width: number
}

const CdnImage = ({
  alt = '',
  className = '',
  height,
  imageHash,
  trim = false,
  transparent = false,
  width,
}: ICdnImageProps) => {
  if (!imageHash) {
    return null
  }

  const image = cdnImageUrl(imageHash as string, {
    width,
    trim,
    transparent,
    height,
  })
  const retinaImage = cdnImageUrl(imageHash as string, {
    height: height * 2,
    trim,
    transparent,
    width: width * 2,
  })

  return (
    <img
      alt={alt}
      className={className}
      data-testid="CdnImage"
      src={image}
      srcSet={`${image} 1x, ${retinaImage} 2x`}
    />
  )
}

export default CdnImage
